<template>
  <div class="container-nav">
    <div class="box-nav">

      <div class="box-btn">
        <a :href="pathStr.contactUs" target="_blank" class="btn-link">
         Support
        </a>
        <a href="https://user.meshare.com" target="_blank" class="btn-link">
          <img src="/static/svg/me.svg">
          Login
        </a>

        <!-- <a href="https://www.meshare.com/contact-us" class="btn get-started">
          Get Started
        </a> -->
      </div>
    </div>
  </div>
</template>

<script>
import jQuery from 'jquery'
export default {
  name: 'Login',
  data () {
    return {
      imgUrl: '/static/images/common/meshare-red.png',
      menuData: [
        {
          name: 'Products',
          path: '',
          children: [
            {
              name: 'IoT Platform',
              describe: 'Deploy on a leading IoT platform that has connected 8+ million devices across the globe.',
              icon: "/static/svg/IoT Platform-2.svg",
              path: '/iot-platform'},
            {
              name: 'HD Video Streaming & Cloud Recording',
              describe: 'Add real-time, HD video & voice streaming, calls, cloud recording, event-based alerts, and more video capabilities.',
              icon: "/static/svg/Cloud-Recording-2.svg",
              path: '/cloud-video-recording-streaming'},
            {
              name: 'Web & Mobile App',
              describe: 'Launch with fully-featured, market-tested mobile and web applications, customized to fit your brand and solutions.',
              icon: "/static/svg/Web & Mobile APP-2.svg",
              path: '/web-and-mobile-app'},
            {
              name: 'meShare Analytics & Growth',
              describe: 'Manage, track and scale your solutions using our powerful user & device management and analytics tools.',
              icon: "/static/svg/x96/meShare Analytics & Growth.svg",
              path: '/analytics-and-growth'},
            {
              name: 'Services',
              describe: 'Utilize end-to-end services from experts in the field to help you launch and grow your business.',
              icon: "/static/svg/Services-2.svg",
              path: '/services'},
          ]
        },
        {
          name: 'Solutions',
          path: '',
          children: [
            {
              name: 'Smart Home & IoT',
              describe: '24/7 Cloud Recording as a monthly subscription for your customers',
              icon: '/static/svg/Smart Home & IoT.svg',
              path: '/smart-home-and-iot',
            },
            {
              name: 'Security & Surveillance',
              describe: 'One-stop-shop with products to help from ideation through launch, to post-launch and growth',
              icon: '/static/svg/Security & Surveillance.svg',
              path: '/security-and-surveillance',
            },
            {
              name: 'Property Management & Real Estate',
              describe: 'Applications help you manage and protect your properties and tenants more efficiently',
              icon: '/static/svg/Property Management & Real Estate.svg',
              path: '/property-management-and-real-estate',
            },
          ]
        },
        // {
        //   name: 'Partner',
        //   path: '/partner',
        //   children: []
        // },
        {
          name: 'Pricing',
          path: '/pricing',
          children: []
        },
      ],
      open: false,
      showpc: true,
      winW: jQuery(window).width(),
      winW2: jQuery(window).width(), //变化
      pathStr: {
        contactUs: '/contact-us'
      }
    }
  },
  watch:{
    '$route':'getPath',
    winW2(val){
      if((val < 800 && this.winW > 800) || (val > 800 && this.winW < 800)){
        this.winW = val;
        this.$forceUpdate()
      }
    }
  },
  mounted(){
    let self = this;

    let lan = this.$cookie.get('x-language');
    if(lan == 'en-us' || lan == 'en-us/'){
      // this.pathStr.contactUs = `/contact-us?lan=en-us`
    }

    jQuery('.nav li>span').on('click', function(){
      if(jQuery(window).width() < 800){
        jQuery(this).siblings('.box-more').slideToggle();
        // console.log(jQuery(this).siblings('.box-more').is(":hidden"))
        if(jQuery(this).siblings('.box-more').is(":hidden")){
          self.open = false
        }else{
          self.open = true
        }
      }
    })

    if(jQuery(window).width() < 800){
      self.showpc = false;
    }

    this.winResize();

    jQuery(window).on('orientationchange', function(){
      console.log(window.orientation)
    })
  },
  methods:{
    openMenuList(){
      if(jQuery('.list-nav').is(":hidden")){
      // if(!this.open){
        this.open = true
        jQuery('.list-nav').fadeIn()
        jQuery('.s-navbox').animate({"margin-left": 0})
      }else{
        this.open = false
        jQuery('.list-nav').fadeOut()
        jQuery('.s-navbox').animate({"margin-left": "-320px"})
      }
      // jQuery('.list-nav').slideToggle();
    },
    getPath(){
      if(jQuery(window).width() < 800){
        this.open = false;
        jQuery('.list-nav').fadeOut()
      }
    },
    winResize(){
      jQuery(window).resize(()=>{
        this.winW2 = jQuery(window).width();
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/common.scss';
.container-nav{
  border-bottom: 1px solid #d6d6d6;
  //background-color: #d6d6d6;
  //background-image: linear-gradient(to bottom left,#f5f8fa, #d6d6d6, #afafaf );
  font-family: 'GothamLight';
  font-weight: bold;
  font-size: 16px;
  padding: 10px 0px 10px 0px;
  box-sizing: border-box;
  max-height: 100px;
  margin-left: 40px;
  margin-right: 40px;
  @media screen and (max-width:$media-max-width){
    padding: 10px;
    position: relative;
  }
  .box-nav{

    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: flex-end;

  }
  .box-logo-nav{
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    @media screen and (max-width:$media-max-width){
      justify-content: space-between;
      width: 100%;
    }
  }
  .btn-nav{
    display: none;
    @media screen and (max-width:$media-max-width){
      display: block;
      width: 25px;
      height: 25px;
      background: url(/static/images/common/01.png) no-repeat;
      background-size: 85%;
      background-position: center;
      &.close-icon{
        background: url(/static/images/common/02.png) no-repeat;
        background-size: 65%;
        background-position: center;
      }
    }
  }
  .btn-none{
    display: none;
    @media screen and (max-width:$media-max-width){
      display: block;
      width: 25px;
      height: 25px;
    }
  }
  .box-logo{
    img{
      width: 131px;
      @media screen and (max-width:$media-max-width){
        width: 110px;
      }
    }
  }
  .list-nav{
    margin-left: 30px;
    z-index: 5;
    @media screen and (max-width:$media-max-width){
      display: none;
      margin-left: unset;
      position: absolute;
      width: 100%;
      background: transparent;
      top: 43px;
      left: 0px;
    }
    .nav{
      display: -webkit-flex;
      display: flex;
      justify-content: start;
      align-items: center;
      @media screen and (max-width:$media-max-width){
        flex-direction: column;
      }
      li{
        position: relative;
        padding: 8px 20px 43px;
        cursor: pointer;
        transition: all .5s;
        @media screen and (max-width:$media-max-width){
          width: 100%;
          box-sizing: border-box;
          text-align: center;
          padding: 8px 20px;
        }
        a{
          color: #333333;
          text-decoration: none;
          @media screen and (max-width:$media-max-width){
            font-size: 100%;
          }
        }
        &:hover{
          @media screen and (min-width:$media-max-width){
            color: #ba0c2f;
            a{
              color: #ba0c2f;
            }
          }
        }
        &.more{
          &:hover{
            color: #333333;
            a{
              color: #333333;
            }
            span{
              @media screen and (min-width:$media-max-width){
                color: #ba0c2f;
              }
            }
            .box-more{
              @media screen and (min-width:$media-max-width){
                display: block;
              }
            }
          }
          .box-more{
            display: none;
            @media screen and (max-width:$media-max-width){
              width: 100%;
            }
          }
          .box-cont{
            position: absolute;
            top: 65px;
            left: 0px;
            width: 400px;
            @media screen and (max-width:$media-max-width){
              position: relative;
              width: 100%;
              top: 0;
              padding: 10px 0 0;
            }
          }
          .list-more{
            background: #ffffff;
            width: 100%;
            display: -webkit-flex;
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;
            justify-content: space-between;
            box-shadow: 0 0 15px 1px rgba(66,66,66,.1);
            border-radius: 10px;
            overflow: hidden;
            @media screen and (max-width:$media-max-width){
              position: relative;
              width: 100%;
              box-shadow: none;
              top: 0;
              padding: 0;
            }
            &.list-col{
              flex-direction: column;
              width: 150px;
            }
            li{
              padding: 10px 25px;
              @media screen and (max-width:$media-max-width){
                text-align: center;
                padding: 5px 25px;
              }
              &:first-of-type{
                padding-top: 25px;
                @media screen and (max-width:$media-max-width){
                  padding-top: 10px;
                }
              }
              &:last-of-type{
                padding-bottom: 25px;
                @media screen and (max-width:$media-max-width){
                  padding-bottom: 10px;
                }
              }
              a{
                @media screen and (max-width:$media-max-width){
                  font-size: 80%;
                }
              }
              &:hover{
                @media screen and (min-width:$media-max-width){
                  background: #f4f6ff;
                }
              }
            }
          }
        }
      }
    }
    .s-nav{
      display: none;
      color: #000000;
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,.5);
      @media screen and (max-width:$media-max-width){
        display: block;
        position: relative;
        z-index: 0;
      }
      .s-navbox{
        padding: 0 20px;
        background: #ffffff;
        padding-bottom: 100vh;
        padding-top: 30px;
        width: 85%;
        max-width: 320px;
        box-sizing: border-box;
        margin-top: 3px;
        margin-left: -320px;
        z-index: 0;
      }
      .blank-clk{
        background: transparent;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
      }
      .s-item{
        border-bottom: 1px solid #f0f0f0;
        &.s-clg2{
          padding-bottom: 10px;
        }
      }
      .s-word1{
        font-family: 'GothamRnd-Book';
        font-size: 16px;
        padding: 10px 0;
      }
      .s-word2{
        font-family: 'GothamRnd-Light';
        font-size: 14px;
        padding: 20px 0;
        a{
          color: #000000;
        }
      }
      .s-word3{
        font-family: 'GothamThin';
        font-size: 14px;
        padding: 10px 0px;
        a{
          color: #000000;
        }
      }
    }
  }
  .box-menu-item{
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: start;
    .mbox-icon{
      width: 24px;
      margin-right: 20px;
      @media screen and (max-width:$media-max-width){
        display: none;
      }
      img{
        width: 29px;
      }
    }
    .mbox-word{
      @media screen and (max-width:$media-max-width){
        width: 100%;
      }
      .title{
        font-family: 'GothamBook';
        font-size: 14px;
        color: #000000;
        margin-bottom: 7px;
        @media screen and (max-width:$media-max-width){
          font-size: 14px;
          font-family: 'GothamThin';
        }
      }
      .describe{
        font-family: 'GothamRnd-Light';
        font-size: 12px;
        color: #3d3d3d;
        @media screen and (max-width:$media-max-width){
          display: none;
        }
      }
    }
  }
  .box-btn{

    display: flex;


    @media screen and (max-width:$media-max-width){
     display: none;
    }
    .btn{
      display: -webkit-flex;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100px;
      height: 29px;
      background: #ba0c2f;
      color: #ffffff;
      font-size: 14px;
      text-decoration: none;
      border-radius: 20px;
      transition: all .7s;
      box-sizing: border-box;
      border: 1px solid #ba0c2f;
      font-family: 'GothamThin';
      &:hover{
        opacity: .9;
      }
      img{
        width: 16px;
        margin-right: 5px;
      }
    }
    .btn-link{
      display: -webkit-flex;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      width: 100px;
      height: 20px;
      color: #000000;
      margin-left: 10px;
      &:hover{
        // color: #ba0c2f;
      }
      img{

        width: 18px;
        margin-right: 5px;
      }
    }
  }
  .icon-triangle{
    &::before{
      content: '';
      display: block;
      position: absolute;
      width: 0px;
      height: 0px;
      top: -14px;
      left: 35px;
      border-top: 7px solid transparent;
      border-right: 5px solid transparent;
      border-bottom: 7px solid #ba0c2f;
      border-left: 5px solid transparent;
      @media screen and (max-width:$media-max-width){
        display: none;
      }
    }
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/header/login.vue